import React from 'react';
import { FaClock, FaMapMarkerAlt } from 'react-icons/fa';
import LocationMap from './LocationMap';
import Button from './ui/Button';
import SectionHeading from './ui/SectionHeading';
import { SITE, STORE_HOURS } from '../constants/site';

function StoreInfo() {
  return (
    <section className="bg-slate-50 py-16 md:py-24" id="store-info" aria-labelledby="visit-heading">
      <div className="mx-auto max-w-7xl px-6">
        <SectionHeading
          id="visit-heading"
          eyebrow="Visit us"
          title="Hours & location"
          subtitle={`${SITE.businessName} — ${SITE.address.full}`}
        />

        <div className="grid gap-10 lg:grid-cols-2 lg:gap-14 lg:items-start">
          <div className="flex flex-col rounded-2xl border border-slate-100 bg-white p-8 shadow-card md:p-10">
            <div className="flex items-center gap-3 text-optical-700">
              <FaClock className="text-2xl shrink-0" aria-hidden />
              <h3 className="font-display text-xl font-semibold text-slate-900">Store hours</h3>
            </div>
            <ul className="mt-6 space-y-3 text-slate-700">
              {STORE_HOURS.map(({ day, hours, closed }) => (
                <li key={day} className="flex justify-between gap-6 border-b border-slate-100 pb-3 text-base last:border-0 last:pb-0">
                  <span className="font-medium text-slate-800">{day}</span>
                  {closed ? (
                    <span className="font-semibold text-optical-700">Closed</span>
                  ) : (
                    <span className="text-right text-slate-600">{hours}</span>
                  )}
                </li>
              ))}
            </ul>

            <div className="mt-10 border-t border-slate-100 pt-8">
              <div className="flex items-start gap-3 text-optical-700">
                <FaMapMarkerAlt className="mt-1 text-2xl shrink-0" aria-hidden />
                <div>
                  <h3 className="font-display text-xl font-semibold text-slate-900">Address</h3>
                  <address className="mt-2 not-italic leading-relaxed text-slate-600">
                    <span className="block font-semibold text-slate-800">{SITE.businessName}</span>
                    {SITE.address.street}
                    <br />
                    {SITE.address.cityLine}
                  </address>
                  <div className="mt-5 flex flex-wrap gap-3">
                    <Button variant="primary" href={SITE.directionsUrl}>
                      Directions in Google Maps
                    </Button>
                    <Button variant="secondary" href={`tel:${SITE.phone.tel}`}>
                      Call {SITE.phone.display}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h3 className="sr-only">Map</h3>
            <LocationMap />
            <p className="mt-4 text-center text-sm text-slate-500">
              Pin shows our storefront on Willis Ave. Use “Directions” for turn-by-turn navigation.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default StoreInfo;
